
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class BookListPop extends Vue {
  @Prop({ default: () => [] }) data: Array<{
    id: number
    name: string
    imgUrl: string
  }>
  visible: boolean = false

  hide() {
    this.visible = false
  }

  open() {
    this.visible = true
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
